<template>
  <div class="home">
    <van-steps :active="active" v-show="active != -1">
      <van-step>{{ isSign ? "个人信息" : "填写个人信息" }}</van-step>
      <van-step>{{ isSign ? "签约信息" : "选择签约机构" }}</van-step>
    </van-steps>
    <hello-world
      v-show="active == -1"
      :signInfo="formData"
      :isSign="isSign"
      :realInfo="realInfo"
      :signCode="signCode"
      @viewDetail="active++"
    />
    <div class="stepbox" v-show="active == 0">
      <van-form @submit="onSubnext" class="formBox">
        <van-field
          name="residentName"
          label="姓名"
          required
          clearable
          placeholder="姓名"
          readonly
          v-model="formData.residentName"
          :rules="[{ required: true, message: '请输入姓名' }]"
        />
        <van-field
          name="identity"
          label="身份证号"
          required
          clearable
          placeholder="身份证号"
          readonly
          :value="maskIdentity(formData.identity)"
          :rules="[
            { required: true, message: '请输入身份证号' },
            {
              validator: () =>
                /(^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|X|x)$)/.test(
                  formData.identity,
                ),
              message: '身份证号格式不正确',
            },
          ]"
        />
        <van-field
          name="phone"
          label="手机号"
          required
          clearable
          placeholder="手机号"
          :readonly="isSign"
          v-model="formData.phone"
          :rules="[
            { required: true, message: '请输入手机号' },
            {
              validator: (value) => /^1[3-9]\d{9}$/.test(value),
              message: '手机号格式不正确',
            },
          ]"
        />
        <van-field
          readonly
          clickable
          required
          name="nation"
          :value="getNationText(formData.nation)"
          label="民族"
          placeholder="点击选择民族"
          :rules="[{ required: true, message: '请选择民族' }]"
          @click="showPickerNation = true"
        />
        <van-popup v-if="!isSign" v-model="showPickerNation" position="bottom">
          <van-picker
            show-toolbar
            :columns="NationList"
            @confirm="onConfirmNation"
            @cancel="showPickerNation = false"
          />
        </van-popup>

        <van-field
          readonly
          clickable
          required
          name="countyName"
          :value="formData.countyName"
          label="现住区县"
          placeholder="点击选择区县"
          :rules="[{ required: true, message: '请选择区县' }]"
          @click="showPicker = true"
        />
        <van-popup v-if="!isSign" v-model="showPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="columns1"
            @confirm="onConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          name="committeeName"
          :value="formData.committeeName"
          label="乡镇/街道"
          placeholder="点击选择乡镇/街道"
          @click="changePicker1()"
        />
        <van-popup v-if="!isSign" v-model="showPicker1" position="bottom">
          <van-picker
            show-toolbar
            :columns="CommitteeList"
            @confirm="onConfirm1"
            @cancel="showPicker1 = false"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          name="townName"
          :value="formData.townName"
          label="村/社区"
          placeholder="点击选择村/社区"
          @click="changePicker2()"
        />
        <van-popup v-if="!isSign" v-model="showPicker2" position="bottom">
          <van-picker
            show-toolbar
            :columns="TownList"
            @confirm="onConfirm2"
            @cancel="showPicker2 = false"
          />
        </van-popup>
        <van-field
          name="address"
          label="详细地址"
          required
          clearable
          placeholder="详细地址"
          :readonly="isSign"
          v-model="formData.address"
          :rules="[{ required: true, message: '请输入详细地址' }]"
        />
        <div class="btn">
          <van-button
            round
            plain
            hairline
            type="primary"
            native-type="submit"
            style="width: 80%"
            >{{ isSign ? "下一页" : "下一步" }}</van-button
          >
        </div>
      </van-form>
    </div>
    <div class="stepbox" v-show="active == 1">
      <van-form @submit="onSubnext1" ref="form" class="formBox">
        <van-field
          readonly
          clickable
          required
          name="orgName"
          :value="formData.orgName"
          label="签约机构"
          placeholder="点击选择签约机构"
          :rules="[{ required: true, message: '请选择签约机构' }]"
          @click="showPicker3 = true"
        />
        <van-popup v-if="!isSign" v-model="showPicker3" position="bottom">
          <van-picker
            show-toolbar
            :columns="OrgList"
            value-key="orgNames"
            @confirm="onConfirm3"
            @cancel="showPicker3 = false"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          required
          name="teamName"
          :value="formData.teamName"
          label="签约团队"
          placeholder="点击选择签约团队"
          :rules="[{ required: true, message: '请选择签约团队' }]"
          @click="changePicker4()"
        />
        <van-popup v-if="!isSign" v-model="showPicker4" position="bottom">
          <van-picker
            show-toolbar
            :columns="TeamList"
            value-key="teamName"
            @confirm="onConfirm4"
            @cancel="showPicker4 = false"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          required
          name="userName"
          :value="formData.userName"
          label="签约医生"
          placeholder="点击选择签约医生"
          :rules="[{ required: true, message: '请选择签约医生' }]"
          @click="changePicker5()"
        />
        <van-popup
          v-if="!isSign"
          v-model="showPicker5"
          position="bottom"
          class="crowdpop"
        >
          <van-picker
            show-toolbar
            :columns="DoctorList"
            value-key="realname"
            @confirm="onConfirm5"
            @cancel="showPicker5 = false"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          required
          autosize
          type="textarea"
          name="crowdsName"
          :value="formData.crowdsName"
          label="所属人群"
          placeholder="点击选择所属人群"
          @click="showPicker6 = true"
          :rules="[{ required: true, message: '请选择所属人群' }]"
        />
        <van-popup
          round
          safe-area-inset-bottom
          v-model="showPicker6"
          position="bottom"
          v-if="!isSign"
          @close="closeCrowdPop()"
          :style="{ height: '80%' }"
        >
          <div class="crowdtitle">选择所属人群</div>
          <van-checkbox-group v-model="formData.crowdsNo" class="crowdGroup">
            <van-checkbox
              style="margin-bottom: 15px;margin-right: 30px;"
              v-for="item in CrowdList"
              :name="item.crowdNo"
              :key="item.crowdNo"
              >{{ item.crowdName
              }}<template #icon="props">
                <img
                  class="img-icon"
                  :src="props.checked ? activeIcon : inactiveIcon"
                /> </template
            ></van-checkbox>
          </van-checkbox-group>
          <div class="btn">
            <van-button
              round
              type="primary"
              @click.prevent="crowdSub()"
              style="width: 80%"
              >确认</van-button
            >
          </div>
        </van-popup>
        <van-field
          readonly
          clickable
          required
          autosize
          type="textarea"
          name="packagesName"
          :value="formData.packagesName"
          label="选择服务包"
          placeholder="点击选择服务包"
          @click="changePicker6()"
          :rules="[{ required: true, message: '请选择服务包' }]"
        />
        <van-popup
          round
          safe-area-inset-bottom
          v-model="showPicker7"
          position="bottom"
          v-if="!isSign"
          @close="closePackPop()"
          :style="{ height: '80%' }"
        >
          <div class="crowdtitle">选择服务包</div>
          <van-checkbox-group
            v-model="formData.packagesNo"
            class="crowdGroup packGroup"
          >
            <van-checkbox
              style="margin: 0 15px 10px 0"
              v-for="item in PackList"
              :key="item.packageNo"
              :name="item.packageNo"
              >{{ item.packageName }}({{ item.orgName }})</van-checkbox
            >
          </van-checkbox-group>
          <div class="btn">
            <van-button
              round
              type="primary"
              @click.prevent="packSub()"
              style="width: 80%"
              >确认</van-button
            >
          </div>
        </van-popup>
        <van-field
          name="signTime"
          label="签约时间"
          required
          placeholder="签约时间"
          v-model="formData.signTime"
          readonly
        />
        <van-field
          readonly
          clickable
          required
          name="signYears"
          :value="formData.signYears"
          label="签约周期（年）"
          placeholder="点击选择签约周期"
          :rules="[{ required: true, message: '请选择签约周期' }]"
          @click="showPicker8 = true"
        />
        <van-popup v-if="!isSign" v-model="showPicker8" position="bottom">
          <van-picker
            show-toolbar
            :columns="SignYearsList"
            @confirm="onConfirm8"
            @cancel="showPicker8 = false"
          />
        </van-popup>
        <div class="btn">
          <van-button
            round
            plain
            hairline
            type="primary"
            @click.prevent="tostep0()"
            :style="{ width: isSign ? '80%' : '40%' }"
            >{{ isSign ? "上一页" : "上一步" }}</van-button
          >
          <van-button
            round
            plain
            hairline
            type="primary"
            native-type="submit"
            style="width: 40%"
            v-if="!isSign"
            >提交</van-button
          >
        </div>
      </van-form>
      <div class="radioRead" v-if="!isSign">
        <van-radio-group v-model="isRead">
          <van-radio name="1" checked-color="#07c160">同意并签署</van-radio
          ><u style="color: #07c160;" @click="opencontent()"
            >《家庭医生签约服务协议》</u
          >
        </van-radio-group>
      </div>
      <van-popup
        class="contentpop"
        v-model="ShowContent"
        closeable
        close-icon="close"
        position="bottom"
        :style="{ height: '80%' }"
      >
        <agreement
          :signInfo="formData"
          :DoctorList="DoctorList"
          :money="money"
          @signature-uploaded="handleSignature"
        ></agreement>
      </van-popup>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import api from "@/services/api/api";
import agreement from "../../components/agreement.vue";
import HelloWorld from "../../components/HelloWorld.vue";
import {
  Step,
  Steps,
  Form,
  Field,
  Picker,
  Popup,
  Toast,
  Button,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
} from "vant";
export default {
  name: "Home",
  components: {
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Form.name]: Form,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    agreement,
    HelloWorld,
  },
  mixins: [],
  props: {},
  data: function() {
    return {
      isSign: false,
      active: -1,
      appid: "",
      formData: {
        signTime: dayjs().format("YYYY-MM-DD"),
        signYears: 1,
        crowdsNo: [],
        crowdsName: "",
        packagesNo: [],
        packagesName: "",
        residentAutographPath: "",
        aqOpenId: "",
        signApplyMsg: "",
      },
      // 添加经纬度字段，供定位使用
      latitude: null,
      longitude: null,
      columns1: [],
      showPicker: false,
      showPicker1: false,
      showPicker2: false,
      showPicker3: false,
      showPicker4: false,
      showPicker5: false,
      showPicker6: false,
      showPicker7: false,
      showPicker8: false,
      showPickerNation: false,
      ShowContent: false,
      isRead: false,
      money: 0,
      CrowdList: [],
      PackList: [],
      CountyList: [],
      CommitteeList: [],
      TownList: [],
      OrgList: [],
      TeamList: [],
      DoctorList: [],
      activeIcon: "https://img01.yzcdn.cn/vant/user-active.png",
      inactiveIcon: "https://img01.yzcdn.cn/vant/user-inactive.png",
      identity: "",
      realInfo: {},
      signCode: null,
      NationList: [
        { text: "汉族", value: "1" },
        { text: "少数民族", value: "99" },
      ],
      SignYearsList: [
        { text: "1年", value: 1 },
        { text: "2年", value: 2 },
        { text: "3年", value: 3 },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    console.log(this.$route.query);
    this.appid = "2021006126659749";
    // this.identity = "371428200403264029";
    // 371428200403264029 //371421200505020432
    this.getUserTokenFun();
    this.getCountyListFun();
  },
  methods: {
    onSubnext(values) {
      console.log("submit", values);
      this.active++;
    },
    onSubnext1(values) {
      console.log("submit", values);
      console.log(this.formData, this.isRead);
      if (!this.isRead) {
        this.$toast("请同意并签署《家庭医生签约服务协议》");
        return;
      }
      // 执行签约提交的处理（人群服务包编号数组转字符串，调用接口）
      this.formData.crowdsNo = this.formData.crowdsNo.join(",");
      this.formData.packagesNo = this.formData.packagesNo.join(",");
      console.log("最终提交的签约信息", this.formData);
      api
        .saveSign(this.formData)
        .then((res) => {
          if (res.code == 200) {
            Toast.success("签约信息已提交");
            setTimeout(() => {
              location.reload();
            }, 2000);
          } else {
            Toast.fail(res.message || "签约失败，请重试");
          }
        })
        .catch((err) => {
          Toast.fail("签约失败，请重试");
        });
    },
    closeCrowdPop() {
      console.log("关闭人群弹窗", this.formData.crowdsNo);
      if (this.formData.crowdsNo.length != 0) {
        // 处理人群名称
        this.formData.crowdsName = "";
        this.CrowdList.forEach((item) => {
          if (this.formData.crowdsNo.includes(item.crowdNo)) {
            if (this.formData.crowdsName) {
              this.formData.crowdsName += "," + item.crowdName;
            } else {
              this.formData.crowdsName = item.crowdName;
            }
          }
        });
        if (this.formData.orgNo != "") {
          // 如果机构名和人群皆不为空，则获取服务包
          this.getPackListFun(this.formData.orgNo, this.formData.crowdsNo);
        }
      } else {
        this.formData.crowdsName = "";
      }
    },
    closePackPop() {
      console.log("关闭服务包弹窗", this.formData.packagesNo);
      if (this.formData.packagesNo.length != 0) {
        // 处理服务包名称
        this.formData.packagesName = "";
        this.money = 0;
        this.PackList.forEach((item) => {
          if (this.formData.packagesNo.includes(item.packageNo)) {
            if (this.formData.packagesName) {
              this.formData.packagesName += "," + item.packageName;
            } else {
              this.formData.packagesName = item.packageName;
            }
            console.log(item);
            this.money = parseFloat((this.money + item.packCost).toFixed(2));
          }
        });
      } else {
        this.formData.packagesName = "";
        this.money = 0;
      }
    },
    crowdSub() {
      this.showPicker6 = false;
    },
    packSub() {
      this.showPicker7 = false;
    },
    onConfirm(e) {
      console.log(e);
      if (this.formData.countyName != e.text) {
        const obj = this.CountyList.find((i) => i.areaCode == e.value);
        this.formData.suffix = obj.suffix;
        this.getOrgListFun(obj.orgNo);
        this.getAreaListFun(e.value, 1);
        // 清空街道村和签约机构等信息
        this.formData.committeeName = "";
        this.formData.committee = "";
        this.formData.townName = "";
        this.formData.town = "";
        this.formData.orgName = "";
        this.formData.orgNo = "";
        this.formData.teamName = "";
        this.formData.teamNo = "";
        this.formData.userName = "";
        this.formData.userNo = "";
        this.formData.packagesName = "";
        this.formData.packagesNo = [];
      }
      this.formData.countyName = e.text;
      this.formData.county = e.value;
      this.showPicker = false;
    },
    changePicker1() {
      if (!this.formData.countyName) {
        this.$toast("请先选择区县");
        return;
      }
      this.showPicker1 = true;
    },
    changePicker4() {
      if (!this.formData.orgName) {
        this.$toast("请先选择机构");
        return;
      }
      this.showPicker4 = true;
    },
    changePicker5() {
      if (!this.formData.teamName) {
        this.$toast("请先选择团队");
        return;
      }
      this.showPicker5 = true;
    },
    changePicker6() {
      if (!this.formData.orgNo || this.formData.crowdsNo.length == 0) {
        this.$toast("请先选择签约机构和人群");
        return;
      }
      this.showPicker7 = true;
    },
    onConfirm1(e) {
      if (this.formData.committeeName != e.text) {
        // 获取村/社区列表
        this.getAreaListFun(e.value, 2);
        this.formData.townName = "";
        this.formData.town = "";
      }
      this.formData.committeeName = e.text;
      this.formData.committee = e.value;
      this.showPicker1 = false;
    },
    changePicker2() {
      if (!this.formData.committeeName) {
        this.$toast("请先选择乡镇/街道");
        return;
      }
      this.showPicker2 = true;
    },
    onConfirm2(e) {
      this.formData.townName = e.text;
      this.formData.town = e.value;
      this.showPicker2 = false;
    },
    onConfirm3(value) {
      if (this.formData.orgName != value.orgName) {
        // 获取团队列表
        this.getTeamListFun(value.orgNo);
        this.formData.teamName = "";
        this.formData.teamNo = "";
        this.formData.userName = "";
        this.formData.userNo = "";
        this.formData.packagesNo = [];
        this.formData.packagesName = "";
        if (this.formData.crowdsNo.length > 0) {
          // 如果机构名和人群皆不为空，则获取服务包
          this.getPackListFun(value.orgNo, this.formData.crowdsNo);
        }
      }
      this.formData.orgName = value.orgName;
      this.formData.orgNo = value.orgNo;
      this.showPicker3 = false;
    },
    onConfirm4(value) {
      if (this.formData.teamName != value.teamName) {
        this.getDoctorListFun(value.teamNo);
        this.formData.userName = "";
        this.formData.userNo = "";
      }
      this.formData.teamName = value.teamName;
      this.formData.teamNo = value.teamNo;
      this.showPicker4 = false;
    },
    onConfirm5(value) {
      this.formData.userName = value.realname;
      this.formData.userNo = value.userNo;
      this.showPicker5 = false;
    },
    onConfirm8(e) {
      this.formData.signYears = e.value;
      this.showPicker8 = false;
    },
    onConfirmNation(e) {
      this.formData.nation = e.value;
      this.showPickerNation = false;
    },
    opencontent() {
      this.$refs.form
        .validate()
        .then(() => {
          this.ShowContent = true;
        })
        .catch(() => {
          this.$toast("请填写完整信息");
        });
    },
    tostep0() {
      this.active = 0;
    },
    getUserTokenFun() {
      const urlObj = this.$route.query;
      api
        .getUserToken({
          appId: this.appid,
          authCode: urlObj.authCode,
        })
        .then((res) => {
          if (res.code == 200) {
            const obj = res.data;
            this.formData.aqOpenId = obj.aqOpenId;
            this.getUserInfoFun(obj.aqAccessToken, obj.aqOpenId);
          }
        });
    },
    getUserInfoFun(aqAccessToken, aqOpenId) {
      api
        .getUserInfo({
          appId: this.appid,
          aqAccessToken: aqAccessToken,
          aqOpenId: aqOpenId,
        })
        .then((res) => {
          if (res.code == 200) {
            this.identity = res.data.certNo;
            this.realInfo = res.data;
            this.getSigndetailFun();
            this.getCrowdListFun();
          }
        });
    },
    //获取token和实名信息后调用
    getSigndetailFun() {
      api
        .getSigndetail({
          appId: this.appid,
          identity: this.identity,
          aqOpenId: this.formData.aqOpenId,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 3 || res.code == 4) {
            this.formData.signApplyMsg = res.msg;
            this.signCode = res.code;
          }
          if (res.code == 500) {
            this.signCode = res.code;
          }
          if (res.data) {
            this.signCode = res.code;
            res.data.crowdsNo = res.data.crowdsNo.split(",");
            res.data.packagesNo = res.data.packagesNo.split(",");
            this.formData = res.data;
            this.isSign = true;

            this.getAreaListFun(res.data.city, 0);
            this.getAreaListFun(res.data.county, 1);
            this.getPackListFun(res.data.orgNo, res.data.crowdsNo);
            if (res.data.committee) {
              this.getAreaListFun(res.data.committee, 2);
            }
            this.getCountyListFun(1);
          } else {
            this.formData.appId = this.appid;
            this.formData.identity = this.identity;
            this.formData.residentName = this.realInfo.certName;
            this.formData.phone = this.realInfo.mobilePhone;
            // 无签约的处理 - 区分地区 - 获取区划 设置省和市的参数
            this.formData.provinceName = "山东省";
            this.formData.province = "370000000000";
            if (this.appid == "2021006126659749") {
              this.formData.cityName = "德州市";
              this.formData.city = "371400000000";
            } else {
              this.formData.cityName = "东营市";
              this.formData.city = "370500000000";
            }
            this.formData.gender = this.parseIdCard(
              this.formData.identity,
            ).gender;
            this.formData.birthday = this.parseIdCard(
              this.formData.identity,
            ).birthDate;
            this.formData.age = this.parseIdCard(this.formData.identity).age;
            this.formData.nation = "1";
            this.getAreaListFun(this.formData.city, 0);
            this.getLocation();
          }
        });
    },
    // 获取经纬度
    getLocation() {
      // 浏览器原生定位接口
      if (navigator && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.latitude = position.coords.latitude;
            this.longitude = position.coords.longitude;
            console.log("定位成功：", this.latitude, this.longitude);
          },
          (error) => {
            console.error("获取经纬度失败", error);
            setTimeout(() => {
              this.$toast("获取位置信息失败，请检查浏览器设置");
            }, 1000);
          },
        );
      } else {
        this.$toast("当前浏览器不支持定位功能");
      }
    },

    getCrowdListFun() {
      api
        .getCrowdList({
          appId: this.appid,
          identity: this.identity,
        })
        .then((res) => {
          console.log(res);
          this.CrowdList = res.data;
        });
    },
    getPackListFun(orgNo, crowdNoList) {
      api
        .getPackList({
          appId: this.appid,
          orgNo: orgNo,
          crowdNoList: crowdNoList,
        })
        .then((res) => {
          console.log(res);
          this.PackList = res.data;
        });
    },
    getOrgListFun(countyNo) {
      api
        .getOrgList({
          appId: this.appid,
          countyNo: countyNo,
          pageNum: 1,
          pageSize: 1000,
          lng: this.longitude,
          lat: this.latitude,
        })
        .then((res) => {
          console.log(res);
          res.rows.forEach((item) => {
            item.orgNames =
              item.orgName + (item.distance ? ` (${item.distance}km)` : "");
          });
          this.OrgList = res.rows;
        });
    },
    getCountyListFun(e) {
      api
        .getCountyList({
          appId: this.appid,
        })
        .then((res) => {
          console.log("辖区", res);
          this.CountyList = res.data;
          if (e == 1) {
            const obj = this.CountyList.find(
              (i) => i.areaCode == this.formData.county,
            );
            this.getOrgListFun(obj.orgNo);
          }
        });
    },
    getAreaListFun(cityId, label) {
      api
        .getAreaList({
          appId: this.appid,
          pid: cityId,
        })
        .then((res) => {
          console.log("区划", res);
          if (label == 0) {
            this.columns1 = res.data.map((item) => ({
              text: item.name,
              value: item.id,
            }));
          } else if (label == 1) {
            this.CommitteeList = res.data.map((item) => ({
              text: item.name,
              value: item.id,
            }));
          } else {
            this.TownList = res.data.map((item) => ({
              text: item.name,
              value: item.id,
            }));
          }
        });
    },
    getTeamListFun(orgNo) {
      api
        .getTeamList({
          appId: this.appid,
          orgNo: orgNo,
          pageNum: 1,
          pageSize: 1000,
        })
        .then((res) => {
          console.log(res);
          this.TeamList = res.rows;
        });
    },
    getDoctorListFun(teamNo) {
      api
        .getDoctorList({
          appId: this.appid,
          teamNo: teamNo,
          pageNum: 1,
          pageSize: 1000,
        })
        .then((res) => {
          console.log(res);
          this.DoctorList = res.rows;
        });
    },
    // 身份证号脱敏显示
    maskIdentity(id) {
      if (!id) return "";
      if (id.length <= 10) return id;
      return id.slice(0, 6) + "********" + id.slice(-4);
    },
    // 解析身份证性别和出生日期
    parseIdCard(idCard) {
      // 提取出生日期：第7-14位 (索引6-13)
      const birthStr = idCard.substring(6, 14);
      const year = birthStr.substring(0, 4);
      const month = birthStr.substring(4, 6);
      const day = birthStr.substring(6, 8);
      const birthDate = `${year}-${month}-${day}`;

      // 性别：第17位 (索引16)，奇数男，偶数女
      const genderCode = parseInt(idCard.charAt(16));
      const gender = genderCode % 2 === 1 ? "1" : "2";

      // 计算年龄
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;
      const currentDay = new Date().getDate();
      const birthYear = parseInt(year);
      const birthMonth = parseInt(month);
      const birthDay = parseInt(day);
      let age = currentYear - birthYear;
      if (
        birthMonth > currentMonth ||
        (birthMonth === currentMonth && birthDay > currentDay)
      ) {
        age--;
      }

      return { birthDate, gender, age };
    },
    handleSignature(fileNo) {
      console.log("Received signature FileNo:", fileNo);
      // 这里可以处理FileNo，比如保存到formData或发送到服务器
      this.formData.residentAutographPath = fileNo;
    },
    getNationText(value) {
      return value == "1" ? "汉族" : "少数民族";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home {
  padding: 0 10px;
}
.stepbox {
  margin-top: 20px;
  margin-bottom: 25vh;
}
.btn {
  width: 100%;
  position: fixed;
  bottom: 1px;
  background: #fff;
  left: 0;
  padding: 10px 0;
  display: flex;
  justify-content: space-evenly;
  z-index: 2;
}
.formBox {
  background: #fff;
  border-radius: 6px;
  padding: 10px;
}
.img-icon {
  height: 20px;
}

.crowdGroup {
  margin-top: 15%;
  display: flex;
  padding: 0 30px;
  flex-direction: row;
  flex-wrap: wrap;
}
.packGroup {
  margin-top: 10%;
  margin-bottom: 20%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
.crowdtitle {
  font-size: 14px;
  margin-top: 15px;
}
.radioRead {
  display: flex;
  justify-content: center;
  margin: 2vh 0 1vh 0;
}
.contentpop {
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  overflow: auto;
}

.van-radio-group {
  display: flex;
  font-size: 14px;
}
.van-cell {
  background-color: #fff0;
}
.van-step--horizontal {
  display: flex;
}
.van-steps {
  background-color: #fff0;
}
::v-deep .van-checkbox__label {
  font-size: 16px !important;
}
::v-deep .van-step--horizontal .van-step__line {
  background-color: #cccccc !important;
}
::v-deep .van-step--horizontal .van-step__circle-container {
  background-color: #fff0 !important;
}
</style>
